import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { ErrorBoundary, WholeScreenLoader } from '@vitvio/shared-components';
import { Suspense, useEffect } from 'react';
import { useTranslation } from '@vitvio/locales';

interface PageProps {
  title: string;
  children: React.ReactNode;
}

export function Page({ title, children }: PageProps) {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${t('common:companyName')} | ${t(title)}`;
  }, [title, t]);

  const { user } = useKindeAuth();

  return (
    <ErrorBoundary userId={user?.id || ''}>
      <Suspense fallback={<WholeScreenLoader />}>{children}</Suspense>
    </ErrorBoundary>
  );
}
